import { environment } from '../../../environments/environment';

export const databasePurchaseUrl = `${environment.flyLegacyUrl}/devices/database-pricing`;
export const gpCatalogUrl = `${environment.flyLegacyUrl}/garmin-pilot/catalog/`;
